import { createAction } from '@reduxjs/toolkit';

import { errorPayloadCreator, getPayloadCreator } from 'app-components/flux/core/actionHelpers';

import type { BaseResource, QcsSyncResourcesPayload } from '../core/resourceStoreTypes';

export const getSSOToken = createAction('GET_SSO_TOKEN', getPayloadCreator<undefined>());
export const getSSOTokenSuccess = createAction(
  'GET_SSO_TOKEN_SUCCESS',
  getPayloadCreator<QcsSyncResourcesPayload<BaseResource>>(),
);
export const getSSOTokenFailure = createAction('GET_SSO_TOKEN_FAILURE', errorPayloadCreator);
